export default "__VITE_ASSET__Dx3pxp7O__"